import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { IvrDatasourceService } from '../../data/ivr-datasource.service';

@Component({
  selector: 'rmi-add-note-button',
  templateUrl: './add-note-button.component.html',
  styleUrls: ['./add-note-button.component.scss']
})
export class AddNoteButtonComponent implements OnInit, OnDestroy {
  @Output() openRelatedEditModal: EventEmitter<void> = new EventEmitter();
  @Input() title: string = '';
  private readonly destroy$ = new Subject<void>();
  show = false;

  constructor(private ivrDataSource: IvrDatasourceService) {}

  ngOnInit(): void {
    this.ivrDataSource.showEditReportButtons$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (showEditReportButton: boolean) => (this.show = showEditReportButton)
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
